export default "__VITE_ASSET__JyA81l1X__"